import cx from "classnames";
import { type FC, useMemo } from "react";

import type { ActiveUser as ActiveUserType } from "@moment/api-collab/api-types";
import { Avatar, AvatarSize } from "@moment/design-system/Avatar";

import { getPresenceColor } from "~/utils/presence";

export interface ActiveUserProps {
	activeUser: ActiveUserType;
	showName?: boolean;
}

export const ActiveUser: FC<ActiveUserProps> = ({ showName = false }) => {
	const loading = false;
	const user = {
		name: "John Doe",
		profilePicture: "https://via.placeholder.com/150",
	};
	const presenceIndex = useMemo(() => 1, []);
	// const presenceIndex = useMemo(
	// 	() => selectionsRef.current?.findIndex((presence) => presence.tabID === activeUser.tabID),
	// 	[selectionsRef.current, activeUser.tabID]
	// );
	const outlineColor: string = useMemo(() => {
		// Default to bg-primary (same as top bar) unless there is a presence color
		const defaultColor = "bg-primary";

		if (presenceIndex === -1 || presenceIndex === undefined) {
			return defaultColor;
		}

		const presenceColor = getPresenceColor(presenceIndex);
		if (presenceColor === undefined) {
			return defaultColor;
		}

		return presenceColor.activeUser;
	}, [presenceIndex]);

	if (loading || !user) {
		return null;
	}

	return (
		<>
			<div className={cx("rounded-full p-[3px] transition-colors", outlineColor)}>
				<div className="bg-primary rounded-full p-px">
					<Avatar
						key={user.name}
						userName={user.name}
						imageURL={user.profilePicture}
						size={AvatarSize.sm}
					/>
				</div>
			</div>
			{showName && <span className="ml-2 text-sm">{user.name}</span>}
		</>
	);
};
